module.exports = __webpack_public_path__ + "app-static/img/ex-1.741e98f2.png";